module.exports = __webpack_public_path__ + "static/media/menu.a73a7d1a.svg";